import { useEffect } from 'react';

import * as S from './styles';
import ExtratoList from '../Extrato/components/ExtratoList';
import PrimaryCard from './components/PrimaryCard';
import SecondaryCard from './components/SecondaryCard';

import { HomePageBanner } from './components/HomePageBanner';
import { RootStateCarteira } from '../../store/carteiraReducer';

import { _UserData, UserDataBaseEnum } from 'base/src/infra/storage/localStorage';
import { GetExtrato } from '../../store/extrato/actions/extratoAction';
import { Icon } from '@iconify/react';
import { GetCarteiraUsuario, GetCarteiraBase, GetCarteiraBasePorCampanha, UpdateCarteiraBase } from 'domain/store/_carteira/carteiraBase/actions/carteiraBaseAction';
import { useTheme } from 'base/src/utils/context/themeContext';

import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { Redirect } from 'base/src/utils/routeUtil';
import { GetAuthRoute } from 'domain/types/sistema/sistemaList';

const connector = connectUtil(
  (state: RootStateCarteira) => ({
    homeInfo: state.CarteiraBaseReducer.CarteiraBase,
    homeInfoCampanha: state.CarteiraBaseReducer.CarteiraBaseCampanha,
    CarteiraUsuario: state.CarteiraBaseReducer.CarteiraUsuario,
    ExtratoRange: state.ExtratoReducer.Extrato,
  }),
  { GetCarteiraBase, UpdateCarteiraBase, GetCarteiraBasePorCampanha, GetCarteiraUsuario, GetExtrato }
);

export interface CarteiraHomeComponentProps extends PropsFromRedux<typeof connector> {
}

function HomePage(props: CarteiraHomeComponentProps) {
  // const homeContainer = new HomeContainer(props);
  const _userData = _UserData;
  const { theme } = useTheme();

  // const { t } = useTranslation();

  const fromDate = new Date(new Date().setDate(new Date().getDate() - 1)).toDateString();
  const toDate = '';

  const request = {
    From: fromDate,
    To: toDate,
  };

  useEffect(() => {
    props.GetCarteiraUsuario(() => { Redirect(GetAuthRoute()) });
  }, []);

  useEffect(() => {
    if (!props.CarteiraUsuario?.length || props.CarteiraUsuario[0].CarteiraID === 0) return;


    props.GetExtrato(request, props.CarteiraUsuario[0].CarteiraID, () => { });
    // homeContainer.GetUserInfo(props.CarteiraUsuario[0].CarteiraID);
    //props.GetHomeInfoPorCampanha(props.CarteiraUsuario[0].CarteiraID, 616);
    // props.GetCampanhas(_userData.Get(UserDataBaseEnum.UsuarioID), _userData.Get(UserDataBaseEnum.EmpresaID), t);
  }, [props.CarteiraUsuario]);

  return (
    <S.Container>
      <S.BannerContainer>
        <HomePageBanner userName={_userData.Get(UserDataBaseEnum.NomeExibicao)} />
      </S.BannerContainer>
      <PrimaryCard />
      <SecondaryCard />
      {/*<TertiaryCard />*/}
      <S.ExtratoContainer>
        <S.HeaderContainer>
          <S.Subtitle>Últimas movimentações</S.Subtitle>
          <S.ExtratoLink>
            <S.StyledLink to='/extrato'>Verificar extrato completo</S.StyledLink>
            <Icon icon="ic:baseline-open-in-new" width={20} color={theme.colors.primary} />
          </S.ExtratoLink>
        </S.HeaderContainer>
        {props.ExtratoRange !== null && (
          <ExtratoList extrato={props.ExtratoRange} hideValues={props.homeInfo.EsconderSaldo} />
        )}
      </S.ExtratoContainer>
    </S.Container>
  );
}

export default connector(HomePage);